// extracted by mini-css-extract-plugin
export default {"root":"Download__root--f9fWU","content":"Download__content--EnPUy","text":"Download__text--hJGMy","button":"Download__button--X8_kb","icon":"Download__icon--acs_u"};